import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";

import { useTimeout} from "../actions";
import { alertSelector, showAlertSelector } from "../reducers";
import { useNavigate } from "react-router";

let previousAlertString;

export default function AlertGlobal() {
  const dispatch = useDispatch();

  const alert = useSelector(alertSelector);
  const showAlert = useSelector(showAlertSelector);

  const handleCloseAlert = useCallback( () => dispatch({ type: "CLOSE_ALERT" }) );

  const { t } = useTranslation();
  const navigate = useNavigate();


  const success = alert && alert.type === "SUCCESS" ? true : false;
  const warning = alert && alert.type === "WARNING" ? true : false;
  const error = alert && alert.type === "ERROR" ? true : false;

  const variant = `${success ? "success" : ""}${warning ? "warning" : ""}${error ? "danger" : ""}`;
  const dismissible = error ? true : false;

  let heading = alert && alert.title ? alert.title : "";
  if (heading === "") {
    heading = alert && alert.titleKey ? t(alert.titleKey, alert.titleDefault) : "";
  }

  let alertBody;

  if (alert) {
    const currentAlertString = JSON.stringify(alert);
    if (previousAlertString !== currentAlertString) {
      previousAlertString = currentAlertString;
      window.jsError && window.jsError({...alert});
    }

    if (alert.message) {
      alertBody = <p>{alert.message}</p>;
    }

    if (alert.messageList) {
      const msgList = [];
      Array.prototype.forEach.call(alert.messageList, (msg) => {
        msgList.push(<li key={msg}>{msg}</li>);
      });
      alertBody = <>{alertBody}<ul>{msgList}</ul></>;
    }

    if (!alertBody && alert.localizedMessages) {
      const localizedMsgs = alert.localizedMessages;
      if (localizedMsgs.length > 1) {
        const msgList = localizedMsgs.map((msg) =>
          <li key={msg.key}>{t(msg.key, msg.defaultValue ?? msg.key, msg.params ?? {})}</li>
        );
        alertBody = <ul>{msgList}</ul>;
      } else if (alert.localizedMessages.length === 1) {
        const msg = alert.localizedMessages[0] ?? {};
        alertBody = <p>{t(msg.key, msg.defaultValue ?? msg.key, msg.params ?? {})}</p>;
      }
    }

    const premiumClick = e => {
      e.preventDefault();
      navigate("/premium");
    };

    if (!alertBody && alert.messageKey) {
      if (alert.messageParams?.premiumLink) {
        alertBody = <Trans i18nKey={alert.messageKey}>
          Tämä toiminto on saatavilla <Alert.Link onClick={premiumClick} href="/premium">Premium-versiossa</Alert.Link>.
        </Trans>;
      } else {
        alertBody = <p>{t(alert.messageKey, alert.messageDefault ?? alert.messageKey, alert.messageParams ?? {})}</p>;
      }
    }

    if (error && !alertBody) {
      alertBody = <p>{t("UnexpectedSystemError", "Järjestelmässä tapahtui odottamaton virhe")}<br />{alert.message}</p>;
    }
  }

  const timeoutDelay = 3000;
  useTimeout(() => handleCloseAlert(), showAlert && !error ? timeoutDelay : null);

  return (
    <Alert className="global-alert" show={showAlert} variant={variant} onClose={handleCloseAlert}
      dismissible={dismissible} transition>
      <Alert.Heading>{heading}</Alert.Heading>
      {alertBody}
    </Alert>
  );
}
